export default {
      id: "color_stressout-usage",
      viewBox: "0 0 41 52",
      url: __webpack_public_path__ + "sprite.svg#color_stressout",
      toString: function () {
        return this.url;
      }
    }